import {INVALIDATE, REQUEST, RESPONSE, FILTER, SELECT_PARENT} from './AdvancedListActions'
import PagingReducer from "./../paging/PagingReducer"
import * as PagingActions from "./../paging/PagingActions"

function getDataKey() {
    var dataKey = "";

    dataKey += JSON.stringify(this.filter);
    if (this.supportPaging) {
        dataKey += "_" + this.paging.getDataKey();
    }

    dataKey += "_" + this.parent;

    return dataKey;
}

const initialState = {
    supportPaging: false,   // je podporované stránkování?
    count: 0,           // celkový počet řádek odpovídajících filtru, BEZ stránkování - slouží pro výpočet stránkování
    rows: [],   // řádky, které odpovídají filtru a stránkování
    dirty: false,   // pokud je true, neodpovídají data filtru, i když jsou načtená, při filtrování neodebráme data
    isFetching: false,
    fetched: false,
    filter: {},
    currentDataKey: "",
    getDataKey: getDataKey,
    reducer: list,
    parent: null,
}

export default function list(state = initialState, action = {}, config = null) {
    // Konfigurace
    if (config) {
        state = {...state}

        // Inicializace na základě konfigu
        if (config.paging !== null && typeof config.paging !== "undefined") { // podpora pro stránkování
            state.supportPaging = config.paging;
            state.paging = PagingReducer();
        }
    }

    // Stránkování
    if (state.supportPaging && PagingActions.is(action)) {
        return {
            ...state,
            paging: PagingReducer(state.paging, action)
        };
    }

    // Vlastní akce
    switch (action.type) {
        case INVALIDATE:
            return {
                ...state,
                currentDataKey: "",
                dirty: true
            };
        case REQUEST:
            return {
                ...state,
                isFetching: true,
                currentDataKey: action.dataKey,
            };
        case SELECT_PARENT:
            return {
                ...state,
                parent: action.parent,
                dirty: true,
            };
        case RESPONSE: {
            return {
                ...state,
                isFetching: false,
                fetched: true,
                dirty: false,

                rows: action.rows,
                count: action.count,
            }
        }
        case FILTER: {
            return {
                ...state,
                filter: action.filter,
                dirty: true,
            }
        }
        default:
            return state
    }
}

